export default __webpack_public_path__ + "static/realWorldImg4-ac22b1893e8c00d4453ab9300fa3af04.webp";